import { Flight } from 'services/SwaggerApi';

export const getFareFamilyType = (service: Flight) => {
    const legs = service.legs || [];
    const familyType = legs[0]?.segments[0].fare_family_type;

    return familyType;
};
